<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ subject.id ? $t('discipline.form.editTitle') : $t('discipline.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('discipline.form.nameLabel') }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="subject.name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="inputUser">
                        <span class="required">*</span> {{ $t('common.status') }}:
                      </label>
                      <select v-model="subject.status" class="form-control">
                        <option :value="1">{{ $t('common.active') }}</option>
                        <option :value="0">{{ $t('common.inactive') }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('discipline.form.descriptionLabel') }}
                      </label>
                      <textarea
                        class="form-control"
                        cols="30"
                        rows="3"
                        v-model="subject.description"
                      ></textarea>
                    </div>
                  </div>

                  <div v-if="subject.id" class="form-group mt-2">
                    <label>{{ $t('discipline.form.mapPinLabel') }}</label>
                    <div class="d-flex align-items-center" style="gap: 12px">
                      <div>
                        <img
                          v-if="subject.pin_icon"
                          :src="subject.pin_icon"
                          style="
                            width: 48px;
                            height: 48px;
                            object-fit: contain;
                            border: 1px solid #ddd;
                            border-radius: 6px;
                          "
                        />
                        <div v-else class="pin-empty-preview">{{ $t('discipline.form.noPinLine1') }}<br />{{ $t('discipline.form.noPinLine2') }}</div>
                      </div>
                      <div>
                        <label
                          v-if="$hasAbility('node.admin')"
                          class="btn btn-sm btn-outline-primary mb-1"
                          style="cursor: pointer"
                        >
                          <feather-icon icon="UploadIcon" size="14" /> {{ $t('discipline.form.uploadPinButton') }}
                          <input
                            type="file"
                            accept="image/*"
                            style="display: none"
                            @change="uploadDisciplinePin"
                          /> </label
                        ><br />
                        <a
                          v-if="subject.pin_icon && $hasAbility('node.admin')"
                          href="#"
                          class="text-danger small"
                          @click.prevent="removeDisciplinePin"
                          >{{ $t('discipline.form.removePinLink') }}</a
                        >
                      </div>
                    </div>
                    <small class="text-muted"
                      >{{ $t('discipline.form.pinHint') }}</small
                    >
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t('discipline.form.requiredFields') }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/discipline" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                    </router-link>
                    <a v-if="$hasAbility('node.admin')" class="btn btn-add" @click="save">
                      {{ $t('common.save') }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      subject: {
        name: "",
        description: "",
        status: "1",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "discipline";

      if (self.subject.id) {
        self.subject._method = "PUT";
        api += "/" + self.subject.id;
      }

      self.$loading(true);

      axios
        .post(api, self.subject)
        .then((response) => {
          self.$message(
            self.$t('discipline.messages.successTitle'),
            self.$t('discipline.messages.saveSuccess'),
            "success",
          );
          self.$loading(false);
          this.$router.push("/discipline");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    uploadDisciplinePin(event) {
      const file = event.target.files[0];
      if (!file || !this.subject.id) return;
      const fd = new FormData();
      fd.append("pin", file);
      this.$loading(true);
      axios
        .post(
          this.$store.state.api + "discipline/" + this.subject.id + "/pin",
          fd,
        )
        .then((r) => {
          this.$set(this.subject, "pin_icon", r.data.pin_url);
          this.$message(this.$t('discipline.messages.successTitle'), this.$t('discipline.messages.pinUpdated'), "success");
        })
        .catch(() => this.$message(null, this.$t('discipline.messages.pinUploadError'), "error"))
        .finally(() => {
          this.$loading(false);
          event.target.value = "";
        });
    },
    removeDisciplinePin() {
      if (!this.subject.id) return;
      this.$loading(true);
      axios
        .delete(
          this.$store.state.api + "discipline/" + this.subject.id + "/pin",
        )
        .then(() => {
          this.$set(this.subject, "pin_icon", null);
          this.$message(this.$t('discipline.messages.successTitle'), this.$t('discipline.messages.pinRemoved'), "success");
        })
        .catch(() => this.$message(null, this.$t('discipline.messages.pinRemoveError'), "error"))
        .finally(() => this.$loading(false));
    },
    getSubject: function (id) {
      const self = this;
      const api = self.$store.state.api + "discipline/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.subject = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getSubject(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
.pin-empty-preview {
  width: 48px;
  height: 48px;
  border: 2px dashed #ccc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #999;
  text-align: center;
}
</style>
